import { __makeTemplateObject } from "tslib";
import { css, flexCenterStyle, spacing, } from '../../../../foundation';
export var ListItemAvatarStyle = function () { return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: ", ";\n    min-width: 0;\n    ", ";\n  "], ["\n    margin: ", ";\n    min-width: 0;\n    ", ";\n  "])), spacing(0.75, 2, 0.75, 0), flexCenterStyle); };
var templateObject_1;
